import React from "react";
import { durationLabel, workedSeconds, workedTimeLabel } from "../../utils/consolidationPresentation.js";
import { plannedServiceMinutes } from "../../utils/consolidationFieldHighlights.js";

// Comparatif des heures, toujours sous le tableau de la journée.
export default function SheetSummary({ row }) {
  const worked = workedSeconds(row);
  const planned = plannedServiceMinutes(row);
  const hasPlan = Number.isFinite(planned) && planned > 0;
  const gap = worked == null || !hasPlan ? null : Math.round(worked / 60 - planned);
  const gapLabel = gap == null ? "—" : gap === 0 ? "0 min"
    : `${gap > 0 ? "+" : "−"}${Math.abs(gap) < 60 ? `${Math.abs(gap)} min` : durationLabel(gap)}`;
  return <div className="flex min-w-0 flex-wrap items-start justify-between gap-x-3 gap-y-1 py-1 text-xs tabular-nums text-slate-600">
    <dl aria-label="Comparatif des heures du chauffeur" className="ml-auto grid grid-cols-[auto_auto] gap-x-3 gap-y-0.5 pr-7 text-right"
      title="Heures travaillées : fin moins début du service, dîner, pauses non payées et tournée d’un autre camion déduits. Dispatch prévu : durée du service prévue au Dispatch, moins le dîner prévu.">
      <dt className="font-medium text-slate-900">Heures travaillées</dt><dd className="whitespace-nowrap font-semibold text-slate-900">{workedTimeLabel(row) || "À compléter"}</dd>
      <dt>Dispatch prévu</dt><dd className="whitespace-nowrap">{hasPlan ? durationLabel(planned) : "Indisponible"}</dd>
      <dt>Écart au dispatch</dt><dd className="whitespace-nowrap font-medium">{gapLabel}</dd>
    </dl>
  </div>;
}
